import {User} from "./models/user";


export interface State {
  user: User;



}

export const initialState: State = {
  user: new User(),



};
